import { render, staticRenderFns } from "./pendingInventory.vue?vue&type=template&id=0377aed3&"
import script from "./pendingInventory.vue?vue&type=script&lang=js&"
export * from "./pendingInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports